export interface IPageEvent {
  type: 'page';
  timestamp: number;
  toJSON(): {
    type: IPageEvent['type'];
    title: string;
    url: string;
    path: string;
    hash: string;
    search: string;
    width: number;
    height: number;
    timestamp: IPageEvent['timestamp'];
  };
}

export default class PageEvent implements IPageEvent {
  readonly type = 'page' as const;

  private title: string;

  private url: string;

  private path: string;

  private hash: string;

  private search: string;

  private width: number;

  private height: number;

  readonly timestamp: number;

  constructor() {
    this.title = document.title;
    this.url = window.location.href;
    this.path = window.location.pathname;
    this.hash = window.location.hash;
    this.search = window.location.search;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.timestamp = new Date().getTime();
  }

  toJSON() {
    return {
      type: this.type,
      title: this.title,
      url: this.url,
      path: this.path,
      hash: this.hash,
      search: this.search,
      width: this.width,
      height: this.height,
      timestamp: this.timestamp,
    };
  }
}
